import { FC } from "react";

import { IconProps } from "./IconProps";

export const Plus: FC<IconProps> = ({
  className,
  size = 16,
  color = "currentColor",
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 31 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M30.7953 18.56H18.1353V31.34H12.7953V18.56H0.195312V13.58H12.7953V0.73999H18.1353V13.58H30.7953V18.56Z"
      fill={color}
    />
  </svg>
);
